import api from './api';

export const roleService = {
  // Create new role (admin only)
  createRole: async (roleData) => {
    const response = await api.post('/role/create', roleData);
    return response.data;
  },

  // Get all roles (admin only)
  getRoles: async () => {
    const response = await api.get('/role/list');
    return response.data;
  },

  // Get role by ID (admin only)
  getRoleById: async (roleId) => {
    const response = await api.get(`/role/${roleId}`);
    return response.data;
  },

  // Add permissions to role (admin only)
  addPermissions: async (roleId, permissions) => {
    const response = await api.post(`/role/add-permissions/${roleId}`, {
      permissions
    });
    return response.data;
  },

  // Remove permissions from role (admin only)
  removePermissions: async (roleId, permissions) => {
    const response = await api.post(`/role/remove-permissions/${roleId}`, {
      permissions
    });
    return response.data;
  },

  // Toggle role active status (admin only)
  toggleActive: async (roleId) => {
    const response = await api.patch(`/role/toggle-active/${roleId}`);
    return response.data;
  },
};
